/**
 * How the four message surfaces should render (PREC-3900).
 *
 * `no-senders` is the long-standing onboarding state: a company that has never connected a
 * sender gets the blurred page and `NoSenderModal`. A **cancelled** company also has no
 * senders — the shutdown disconnects them — and used to fall into exactly that state, which
 * is why a customer who had just cancelled found their inbox unreadable behind "No senders
 * set up yet". A cancelled company is `read-only` instead: the page renders in full, and only
 * the send affordances are gone.
 */
export type MessagesAccessMode = "normal" | "no-senders" | "read-only";

const READ_ONLY_STATES = ["GRACE", "ARCHIVED", "DUE_FOR_DELETION"];

export function resolveMessagesAccessMode(input: {
	lifecycleState?: string;
	hasSendingUsers: boolean;
	sendingUsersLoaded: boolean;
}): MessagesAccessMode {
	if (input.lifecycleState && READ_ONLY_STATES.includes(input.lifecycleState)) {
		return "read-only";
	}

	// Until the query resolves, assume the healthy case — otherwise every page load flashes
	// the no-senders modal.
	if (!input.sendingUsersLoaded || input.hasSendingUsers) {
		return "normal";
	}

	return "no-senders";
}
